module.exports = __webpack_public_path__ + "img/ccl_main1.354b5f8d.jpg";